import { History } from '@mui/icons-material';
import { formatDateTime } from '../utils/utils';
import { HistoryTableProps } from './HistoryTable.types';

import './HistoryTable.css';
/**
 * Displays a table of order number change history
 * Shows division, legal entity, previous/new numbers, initiator, and timestamp
 * Responsive layout with mobile-optimized display

 */
export function HistoryTable({ numberingHistory, bodyRef }: HistoryTableProps): JSX.Element {
  if (!Array.isArray(numberingHistory) || numberingHistory.length === 0) {
    return (
      <div className="tab-content">
        <div className="no-data">
          <History sx={{ fontSize: '3rem', marginBottom: '1rem', color: '#ccc' }} />
          <p>Немає історії змін</p>
        </div>
      </div>
    );
  }

  return (
    <div className="history-results-container">
      <div className="history-table-wrapper" ref={bodyRef}>
        <table className="history-results-table">
          <tbody>
            {numberingHistory.map(history => (
              <tr key={history.id} className="history-table-row">
                <td className="history-table-cell history-col-division">{history.division_name}</td>
                <td className="history-table-cell history-col-entity">{history.legal_entity_name}</td>
                <td className="history-table-cell history-col-prev-number">{history.old_number}</td>
                <td className="history-table-cell history-col-new-number">{history.new_number}</td>
                <td className="history-table-cell history-col-initiator">{history.changed_by_name}</td>
                <td className="history-table-cell history-col-datetime">{formatDateTime(history.created_at)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
